module.exports = __webpack_public_path__ + "img/bs-2.2c84c00f.jpg";